import * as lightGreen from "../colors/lightGreen";
import * as green from "../colors/green";
import * as lime from "../colors/lime";
import * as aqua from "../colors/aqua";
import * as blue from "../colors/blue";
import * as cyan from "../colors/cyan";
import * as teal from "../colors/teal";
import * as lightBlue from "../colors/lightBlue";
import * as purple from "../colors/purple";
// FIXME: not sure if this is needed. if yes, should probably also include all the overrides from light-contrast, dark, dark-contrast, etc.
export const visualizationDefaultLight = {
    visualizationOne: {
        contrast: purple.purpleA1000,
        base: purple.purple600,
        gradient: purple.purple500,
        highlight: purple.purple200,
        hint: purple.purple50,
        inverseContainer: purple.purple600
    },
    visualizationTwo: {
        contrast: lightBlue.lightBlueA1000,
        base: lightBlue.lightBlue500,
        gradient: lightBlue.lightBlue400,
        highlight: lightBlue.lightBlue200,
        hint: lightBlue.lightBlue50
    },
    visualizationThree: {
        contrast: aqua.aquaA1000,
        base: aqua.aqua500,
        gradient: aqua.aqua400,
        highlight: aqua.aqua200,
        hint: aqua.aqua50,
        inverseContainer: aqua.aqua900
    },
    visualizationFour: {
        contrast: blue.blueA1000,
        base: lightBlue.lightBlue700,
        gradient: lightBlue.lightBlue600,
        highlight: blue.blue200,
        hint: blue.blue50,
        inverseContainer: blue.blue600
    },
    visualizationFive: {
        contrast: cyan.cyanA1000,
        base: cyan.cyan600,
        gradient: cyan.cyan500,
        highlight: cyan.cyan200,
        hint: cyan.cyan50,
        inverseContainer: cyan.cyan700
    },
    visualizationSix: {
        contrast: teal.tealA1000,
        base: teal.teal900,
        gradient: teal.teal800,
        highlight: teal.teal200,
        hint: teal.teal50,
        inverseContainer: teal.teal800
    },
    visualizationSeven: {
        contrast: green.greenA1000,
        base: green.green400,
        gradient: green.green300,
        highlight: green.green200,
        hint: green.green50
    },
    visualizationEight: {
        contrast: lightGreen.lightGreenA1000,
        base: lightGreen.lightGreen800,
        gradient: lightGreen.lightGreen700,
        highlight: lightGreen.lightGreen200,
        hint: lightGreen.lightGreen50
    },
    visualizationNine: {
        contrast: lime.limeA1000,
        base: lime.lime600,
        gradient: lime.lime500,
        highlight: lime.lime200,
        hint: lime.lime50
    }
};
